module.exports = __webpack_public_path__ + "img/ic_kszc_hover.3469c9cb.svg";